'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

import { capturePostHogError } from '@/hooks/useErrorTracking';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Add a custom message with error context
    Sentry.captureMessage(`Global Error Triggered: ${error.message}`, {
      level: 'fatal', // Set severity level
      tags: {
        errorType: 'global_error',
        errorDigest: error.digest || 'no-digest'
      },
      extra: {
        stack: error.stack,
        timestamp: new Date().toISOString()
      }
    });
    Sentry.captureException(error);

    // global-error replaces the root layout, so there is no provider tree here —
    // the plain capture function needs none. It no-ops if the root layout blew
    // up before posthog.init ever ran; Sentry covers that case.
    capturePostHogError(error, {
      error_source: 'global_error_boundary',
      error_code: error.digest || 'no-digest',
      error_message: error.message
    });
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
